<template>
  <div>
    <Head title="Create Vendor" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/vendors">Vendors</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.vendorname" :error="form.errors.ve" class="pb-8 pr-6 w-full lg:w-1/2" label="Vendor Name" />
          <select-input v-model="form.contactuser" :error="form.errors.contactuser" class="pb-8 pr-6 w-full lg:w-1/2" label="User for Order Emails">
              <option :value="null">--No Email Contact--</option>
            <template v-for="u in users">
              <option :value="u.id">{{u.email}} - {{u.last_name}}, {{u.first_name}}</option>
            </template>
          </select-input>
          <text-input v-model="form.contactuser" :error="form.errors.ve" class="pb-8 pr-6 w-full lg:w-1/2" label="Order-Email User" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Phone" />
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Address" />
          <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="City" />
          <text-input v-model="form.region" :error="form.errors.region" class="pb-8 pr-6 w-full lg:w-1/2" label="Province/State" />
          <select-input v-model="form.country" :error="form.errors.country" class="pb-8 pr-6 w-full lg:w-1/2" label="Country">
            <option :value="null" />
            <option value="US">United States</option>
            <option value="CA">Canada</option>
            <option value="MX">Mexico</option>
          </select-input>
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Postal code" />
          <file-input v-model="form.logo" :error="form.errors.logo" class="pb-8 pr-6 w-1/2 " type="file" accept="image/*" label="Logo" />
          <div class="w-1/2">
            <div v-for="OrderType in OrderTypes" class="w-full pb-5">
              <label>
                {{ OrderType }}
                <input type="checkbox" class="ordertype" :name="OrderType" />
              </label>
            </div>
          </div>
          <input type="hidden" v-model="form.ordertypes" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Vendor</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import {
  OrderTypes,
} from "./../../../enums";

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    users: Object,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        vendorname: null,
        contactuser: null,
        phone: null,
        address: null,
        city: null,
        region: null,
        country: null,
        postal_code: null,
        ordertypes: null,
        logo: null,
      }),
      OrderTypes,
    }
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    store() {
      var ordertypes = [];
      document.querySelectorAll('.ordertype').forEach(function(v) {
          if (v.checked) { ordertypes.push(v.name) }
      });
      this.form.ordertypes = ordertypes;
      this.form.post('/vendors')
    },
  },
}
</script>
